// import { getAuthenticatedInstance } from './helpers/helpers';
import { planningsResponse } from './mock/planning/planning.mock';

// const authenticatedInstance = getAuthenticatedInstance();

export async function getPlannings(): Promise<any> {
  //   return authenticatedInstance.get('/sounds');
  return planningsResponse;
}
